class DetailsModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    /*
      Ausschließlich der echte Modal-Close-Button.
      Keine Suche nach dem "ersten button[type=button]" mehr.
    */
    this.closeButton = this.querySelector(
      '[data-wm-search-close], .modal__close-button'
    );

    if (!this.detailsContainer || !this.summaryToggle) {
      return;
    }

    this.onBodyClickEvent =
      this.onBodyClick.bind(this);

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => {
        if (
          event.code.toUpperCase() ===
          'ESCAPE'
        ) {
          this.close();
        }
      }
    );

    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    if (this.closeButton) {
      this.closeButton.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopPropagation();

          this.close();
        }
      );
    }

    this.summaryToggle.setAttribute(
      'role',
      'button'
    );
  }


  isOpen() {
    return this.detailsContainer.hasAttribute(
      'open'
    );
  }


  onSummaryClick(event) {
    event.preventDefault();

    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }


  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains(
        'modal-overlay'
      )
    ) {
      this.close(false);
    }
  }


  open() {
    this.detailsContainer.setAttribute(
      'open',
      true
    );

    document.body.addEventListener(
      'click',
      this.onBodyClickEvent
    );

    document.body.classList.add(
      'overflow-hidden'
    );

    const focusContainer =
      this.detailsContainer.querySelector(
        '[tabindex="-1"]'
      );

    const focusInput =
      this.detailsContainer.querySelector(
        'input:not([type="hidden"])'
      );

    if (
      focusContainer &&
      focusInput &&
      typeof trapFocus === 'function'
    ) {
      trapFocus(
        focusContainer,
        focusInput
      );
    }
  }


  close(focusToggle = true) {
    /*
      Predictive Search intern vollständig zurücksetzen.
    */
    const predictiveSearch =
      this.querySelector(
        'predictive-search'
      );

    if (predictiveSearch) {
      if (
        typeof predictiveSearch.resetForModalClose ===
        'function'
      ) {
        predictiveSearch.resetForModalClose();

      } else if (
        typeof predictiveSearch.close ===
        'function'
      ) {
        predictiveSearch.close(true);
      }
    }


    /*
      Fokus-Trap lösen.
    */
    if (
      typeof removeTrapFocus ===
      'function'
    ) {
      removeTrapFocus(
        focusToggle
          ? this.summaryToggle
          : null
      );
    }


    /*
      DER eigentliche Dialog-Close.
    */
    this.detailsContainer.removeAttribute(
      'open'
    );


    document.body.removeEventListener(
      'click',
      this.onBodyClickEvent
    );


    document.body.classList.remove(
      'overflow-hidden'
    );
  }
}


customElements.define(
  'details-modal',
  DetailsModal
);